import BaseApi from '../baseApi';
import Axios from "@/api/baseApi";

export default {
  complete(form) {
    return BaseApi.post('/api-piglet/api/delivery/complete/v1', form);
  },
  fetchById(id) {
    return BaseApi.get(`/api-piglet/api/delivery/v1/${id}`);
  },
  isDuplicate(producerId, deliveryDate) {
    return Axios.get(`/api-piglet/api/delivery/duplicate/v1?producerId=${producerId}&deliveryDate=${deliveryDate}`);
  },
  printById(id, context) {
    return BaseApi.get(`/api-piglet/api/delivery/print/v1/${context}/${id}`);
  },
  remove(id) {
    return BaseApi.delete(`/api-piglet/api/delivery/${id}/v1`);
  },
  removeMulti(idsToDelete) {
    return BaseApi.post(`/api-piglet/api/delivery/delete-multi/v1`, idsToDelete);
  },
  save(form) {
    return BaseApi.post('/api-piglet/api/delivery/v1', form);
  },
  cancel(storageIds) {
    return BaseApi.post(`/api-piglet/api/delivery/cancel/v1`, storageIds);
  },
  reOpen(storageIds) {
    return BaseApi.post(`/api-piglet/api/delivery/re-open/v1`, storageIds);
  }
}
